module.exports = __webpack_public_path__ + "media/images/proof_links/colored/snapchat-a62d70c282df0af765ee410df7ecfc85.svg";